import axios from 'axios';
import { sign } from '@/common/utils'

// 创建axios实例
const api = axios.create({
  baseURL: '', // API的基础URL
  timeout: 10000, // 请求超时时间
  //headers: {'X-Custom-Header': 'foobar'} // 设置默认的请求头
});

// 添加请求拦截器
// api.interceptors.request.use(config => {
//   // 在发送请求之前做些什么，例如添加token等
//   config.headers.Authorization = `Bearer ${localStorage.getItem('ght_token')}`;
//   return config;
// }, error => {
//   // 对请求错误做些什么
//   return Promise.reject(error);
// });
 
// 添加响应拦截器
api.interceptors.response.use(response => {
  // 对响应数据做点什么
  console.log('response', response)
  if(response.data.code === 401 || response.data.code ===403) {
    sign()
  }
  return response.data;
}, error => {
  // 对响应错误做点什么
  if (error.response.status === 401) {
    // 例如，处理401未授权错误，可以重定向到登录页面等
    sign()
  }
  return Promise.reject(error);
});

export default api